<template>
	<div class="contentbox">
		<div class="media-add-video-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<el-form-item label="链接名称" prop="title">
						<el-input v-model="formInline.title" placeholder="请输入链接名称" clearable
							@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="描述" prop="describe">
						<el-input v-model="formInline.describe" placeholder="请输入描述" clearable
							@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item label="投放链接ID" prop="postlinkId">
						<el-input v-model="formInline.postlinkId" placeholder="请输入投放链接ID" clearable
							@keyup.enter.native="search" @clear="search" style="width: 200px;"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
					<br />
					<el-form-item>
						<el-button type="success" icon="el-icon-circle-plus-outline" @click="addData">添加</el-button>
						<span class="ml-16"><i class="el-icon-refresh-right" style="color: #409eff;margin-right: 5px;"></i>{{countdown}}秒后数据刷新</span>
						<el-button class="ml-16" type="primary" icon="el-icon-document-copy" @click="copyLink('gdt')">复制广点通监测链接</el-button>
						<el-button class="ml-16" type="primary" icon="el-icon-document-copy" @click="copyLink('jl')">复制巨量监测链接</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle" v-loading="loading">
					<el-table-column prop='' label="序号" width="60" fixed>
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column label="链接名称/描述" width="150" fixed>
						<template slot-scope="scope">
							<div class="td-info">
								<p>链接名称：{{ scope.row.title }}</p>
								<p>描述：{{ scope.row.linkDescribe }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="投放链接ID" prop="id" width="140" fixed>
					</el-table-column>
					<el-table-column label="推广链接/小程序路径" width="400">
						<template slot-scope="scope">
							<div class="td-info">
								<p>
									投放路径：
									<span v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' " style="color: #58c523;cursor: pointer;font-weight: 600;" @click="copyWxUrl(scope.row)">点击复制访问链接</span>
									<span v-else  style="color: #58c523;cursor: pointer;font-weight: 600;" @click="copyDyUrl(scope.row)">点击复制访问链接</span>
								</p>
								<p>
									小程序path：{{ scope.row.appPath }}
									<span style="color: #58c523;cursor: pointer;font-weight: 600; margin-left: 10px;" @click="copyText(scope.row.appPath)">点击复制</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="绑定小程序" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p v-if="platform == 'wx-sv' || platform == 'wx-gg-sv' " >原始id：{{ scope.row.wxAccount }}</p>
								<p>appid：{{ scope.row.appid }}</p>
								<p>小程序名称：{{ scope.row.appidName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="剧集信息" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p>短剧名：{{ scope.row.svName }}</p>
								<p>别名：{{ scope.row.aliasName }}</p>
								<p>跳转集数：{{ scope.row.epNumber }}</p>
								<p>免费集数：{{ scope.row.userFreeEp }}</p>
								<p>每集金币数：{{ scope.row.epPrice }}</p>
								<p>解锁模式：
									<span v-if="scope.row.priceFlag == 0">纯付费解锁</span>
									<!-- <span v-if="scope.row.priceFlag == 1">纯整剧付费</span> -->
									<span v-if="scope.row.priceFlag == 2">纯广告解锁</span>
									<span v-if="scope.row.priceFlag == 3">单集付费+广告解锁</span>
								</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="方案配置" width="200">
						<template slot-scope="scope">
							<div class="td-info">
								<p v-if="scope.row.posterName">广告解锁方案：{{ scope.row.posterName }}</p>
								<p v-if="scope.row.rechargeName">充值方案：{{ scope.row.rechargeName }}</p>
								<p>回传方案：{{ scope.row.postbackName }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="总充值金额" width="100">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{ scope.row.totalMoney || 0 }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="当日充值金额" width="120">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{ scope.row.todayMoney || 0 }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="创建时间" width="150">
						<template slot-scope="scope">
							<div class="td-info">
								<p>{{ scope.row.addTime }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="350" fixed="right">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.id)">详情</el-button>
							<el-button type="primary" icon="el-icon-edit" size="mini"
								@click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right;">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini"
										@click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete"
									size="mini">删除</el-button>
							</el-popover>
							<el-dropdown trigger="click" style="margin-left: 10px;">
								<el-button type="success" size="mini">
									更多<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="addVid" @click.native="handleGoRecharge(scope.row.id)">一键跳转充值记录</el-dropdown-item>
									<el-dropdown-item command="addVid" @click.native="DataUpdates(scope.row)">{{ scope.row.disable==1?'开启数据更新':'暂停数据更新'}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background
						:current-page="currentPage" layout="sizes, prev, pager, next, jumper, ->, total"
						:total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">链接名称/名称</td>
						<td>
							<div class="td-info">
								<p>链接名称：{{ rowForm.title }}</p>
								<p>描述：{{ rowForm.linkDescribe }}</p>
							</div>
						</td>
					</tr>
					<tr>
						<td>投放链接ID</td>
						<td>
							{{ rowForm.id }}
						</td>
					</tr>
					<tr>
						<td>推广链接/小程序路径</td>
						<td>
							<p>投放路径：{{ rowForm.link }}</p>
							<p>小程序path：{{ rowForm.appPath }}</p>
						</td>
					</tr>
					<tr>
						<td>剧集信息</td>
						<td>
							<p>短剧名：{{ rowForm.svName }}</p>
							<p>别名：{{ rowForm.aliasName }}</p>
							<p>跳转集数：{{ rowForm.epNumber }}</p>
							<p>免费集数：{{ rowForm.userFreeEp }}</p>
							<p>每集金币数：{{ rowForm.epPrice }}</p>
							<p>解锁模式：
								<span v-if="ruleForm.priceFlag == 0">纯付费解锁</span>
								<!-- <span v-if="ruleForm.priceFlag == 1">纯整剧付费</span> -->
								<span v-if="ruleForm.priceFlag == 2">纯广告解锁</span>
								<span v-if="ruleForm.priceFlag == 3">单集付费+广告解锁</span>
							</p>
						</td>
					</tr>
					<tr>
						<td>方案配置</td>
						<td>
							<p v-if="rowForm.posterName">广告解锁方案：{{ rowForm.posterName }}</p>
							<p v-if="rowForm.rechargeName">充值方案：{{ rowForm.rechargeName }}</p>
							<p>回传方案：{{ rowForm.postbackName }}</p>
						</td>
					</tr>
					<tr>
						<td>总充值金额</td>
						<td>
							<p>{{ rowForm.totalMoney || 0 }}</p>
						</td>
					</tr>
					<tr>
						<td>当日充值金额</td>
						<td>
							<p>{{ rowForm.todayMoney || 0 }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="150px" class="input350" size="small"
				style="max-height: 550px;overflow: auto; padding-right: 20px;">
				<el-form-item label="链接名称：" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入广告ID"></el-input>
				</el-form-item>
				<el-form-item label="描述：" prop="linkDescribe">
					<el-input v-model="ruleForm.linkDescribe" placeholder="请输入描述"></el-input>
				</el-form-item>
				<el-form-item label="选择短剧：" prop="strategyId">
					<el-tag closable @close="handleCloseTagVideo" v-if="ruleForm.svName"
						style="margin-right: 10px;">{{ ruleForm.svName }}</el-tag>
					<el-button type="primary" size="small" :disabled="ruleForm.updateType == 'edit' ? true : false"
						@click="isShowDialogVideo = true">选择</el-button>
					<el-input v-model="ruleForm.aliasName" style="display: none;"></el-input>
					<el-input v-model="ruleForm.strategyId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="短剧解锁模式：" prop="priceFlag">
					<el-select v-model="ruleForm.priceFlag" filterable clearable placeholder="请选择短剧解锁模式" @change="changePriceFlag" >
						<el-option
							v-for="item in priceFlagOptions"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="跳转集数：" prop="epNumber">
					<el-input type="number" v-model="ruleForm.epNumber" placeholder="请输入总集数"></el-input>
				</el-form-item>
				<el-form-item label="免费集数：" prop="userFreeEp">
					<el-input type="number" v-model="ruleForm.userFreeEp" placeholder="请输入免费集数"></el-input>
				</el-form-item>
				<el-form-item label="每集金币数：" prop="epPrice">
					<el-input type="number" v-model="ruleForm.epPrice" placeholder="请输入每集金币数"></el-input>
				</el-form-item>
				<el-form-item label="解锁方案：" prop="unlockPlan">
					<el-radio-group v-model="unlockPlan">
							<el-radio :label="1" :disabled="ruleForm.priceFlag != 2">广告解锁方案</el-radio>
							<el-radio :label="2" :disabled="ruleForm.priceFlag == 2">充值方案</el-radio>
					</el-radio-group><br />
					<el-tag closable @close="handleCloseTagAdUnlock" v-if="ruleForm.posterName || ruleForm.rechargeName"
						style="margin-right: 10px;">{{ ruleForm.posterName || ruleForm.rechargeName }}</el-tag>
					<!-- <el-button type="primary" size="small" @click="changeAdUnlock">选择</el-button> -->
					<el-button type="primary" size="small" @click="changeUnlockPlan">选择</el-button>
					<el-input v-model="ruleForm.posterId" style="display: none;" v-if="unlockPlan == 1"></el-input>
					<el-input v-model="ruleForm.rechargeId" style="display: none;" v-if="unlockPlan == 2"></el-input>

					<!-- <el-tag closable @close="handleCloseTagRecharge" v-if="unlockPlan == 2 && ruleForm.rechargeName"
						style="margin-right: 10px;">{{ ruleForm.rechargeName }}</el-tag>
					<el-button type="primary" size="small" @click="changeRecharge" v-if="unlockPlan == 2">选择</el-button>
					<el-input v-model="ruleForm.rechargeId" style="display: none;" v-if="unlockPlan == 2"></el-input> -->
				</el-form-item>
				<!-- <el-form-item label="广告解锁方案：" prop="posterId">
					<el-tag closable @close="handleCloseTagAdUnlock" v-if="ruleForm.posterName"
						style="margin-right: 10px;">{{ ruleForm.posterName }}</el-tag>
					<el-button type="primary" size="small" @click="changeAdUnlock">选择</el-button>
					<el-input v-model="ruleForm.posterId" style="display: none;"></el-input>
				</el-form-item>
				<el-form-item label="充值方案：" prop="rechargeId">
					<el-tag closable @close="handleCloseTagRecharge" v-if="ruleForm.rechargeName"
						style="margin-right: 10px;">{{ ruleForm.rechargeName }}</el-tag>
					<el-button type="primary" size="small" @click="changeRecharge">选择</el-button>
					<el-input v-model="ruleForm.rechargeId" style="display: none;"></el-input>
				</el-form-item> -->
				<el-form-item label="选择回传方案：" prop="postbackId">
					<el-tag closable @close="handleCloseTagReturn" v-if="ruleForm.postbackName"
						style="margin-right: 10px;">{{ platform == 'wx-sv' || platform == 'wx-gg-sv' ? '广点通+' : '巨量+' }}{{ ruleForm.postbackName }}</el-tag>
					<el-button type="primary" size="small" @click="isShowDialogReturn = true">选择</el-button>
					<el-input v-model="ruleForm.postbackId" style="display: none;"></el-input>
					<span style="color: #a5a4a4;font-size: 12px;padding: 0 8px;">该回传方案针对{{ platform == 'wx-sv' || platform == 'wx-gg-sv' ? '广点通' : '巨量' }}投放平台生效</span>
				</el-form-item>
				<el-form-item label="绑定小程序：">
					<el-input v-model="ruleForm.appidName" disabled="disabled"></el-input>
				</el-form-item>
				<!--<el-form-item label="选择小程序：" prop="bindAppid">-->
				<!--<app-list @getAppId="getAppId" :appId="ruleForm.bindAppid"></app-list>-->
				<!--</el-form-item>-->
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" v-debounce:500="editDialogSureBtn">确 定</el-button>
			</div>
		</el-dialog>
		<video-table :visible.sync="isShowDialogVideo" :appId="ruleForm.appid" :selectVideo="selectVideo"
			@videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo"></video-table>
		<ad-unlock-table :visible.sync="isShowDialogAdUnlock" :svId="ruleForm.svId" :posterId="ruleForm.posterId"
			:selectAdUnlock="selectAdUnlock" @adUnlockSure="adUnlockSure"
			@cancelDialogAdUnlock="cancelDialogAdUnlock"></ad-unlock-table>
		<return-table :visible.sync="isShowDialogReturn" :svId="ruleForm.svId" :postbackId="ruleForm.postbackId"
			:posterId="ruleForm.posterId" :rechargeId="ruleForm.rechargeId" :selectReturn="selectReturn" :postbackType="postbackType"
			@returnSure="returnSure" @cancelDialogReturn="cancelDialogReturn"></return-table>
		<agent-pop :visible.sync="isShowDialogAgent"></agent-pop>
		<recharge-table :visible.sync="isShowRechargeTable" :rechargeId="ruleForm.rechargeId" :appId="ruleForm.appid"
			:selectRecharge="selectRecharge" @rechargeSure="rechargeSure"
			@cancelDialogRecharge="cancelDialogRecharge"></recharge-table>
	</div>
</template>
<script>
import VideoTable from '@/components/VideoTable';
import AdUnlockTable from '@/components/AdUnlockTable';
import ReturnTable from '@/components/ReturnTable';
import AgentPop from '@/components/AgentPop'
import RechargeTable from '@/components/RechargeTable'
import { list, add, details, del,disable } from "@/api/dysvzk/agentmenu/link";
// import {planList, } from "@/api/dysvzk/agentmenu/recharge";
export default {
	components: {
		VideoTable,
		AdUnlockTable,
		ReturnTable,
		AgentPop,
		RechargeTable
	},
	data() {
		var validateNum = (rule, value, callback) => {
			if (!(/(^[1-9]\d*$)/.test(value))) {
				return callback(new Error('数字应为正整数'));
			} else {
				callback();
			}
		};
		return {
			loading:false,
			formInline: {
				title: '',
				describe: '',
				postlinkId: '',
				planName: '',
				appid: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 1,
				result: []
			},
			currentPage: 1,
			dialogInfoVisible: false, // 详情弹框
			dialogTitle: '添加',
			dialogFormVisible: false, // 编辑弹框
			rowForm: {},
			svId: 0,
			unlockPlan:1,//充值方案
			ruleForm: {
				addTime: '',
				aliasName: '',
				svId: 0,
				svName: '',
				agentId: 0,
				appPath: '',
				appid: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
				appidName: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName,
				epNumber: '',
				id: 0,
				link: '',
				linkDescribe: '',
				postbackId: '',
				postbackName: '',
				posterId: '',
				posterName: '',
				rechargeId: 0,
				rechargeName: '',
				strategyId: '',
				title: '',
				updateType: '',
				priceFlag:'',
				userFreeEp:'',
				epPrice:'',
				postType:''
			},
			rules: {
				strategyId: [
					{ required: true, message: '请选择短剧', trigger: 'change' }
				],
				epNumber: [
					{ required: true, message: '请输入跳转集数', trigger: 'blur' },
					{ validator: validateNum, trigger: 'blur' }
				],
				postbackId: [
					{ required: true, message: '请选择回传方案', trigger: 'change' }
				],
				priceFlag:[
					{ required: true, message: '请选择短剧解锁模式', trigger: 'change' }
				],
				userFreeEp:[
					{ required: true, message: '请输入免费集数', trigger: 'change' }
				],
				epPrice:[
					{ required: true, message: '请输入每集金币数', trigger: 'change' }
				]
			},
			isShowDialogVideo: false, // 短剧弹框
			selectVideo: {},
			isShowDialogAdUnlock: false, // 广告弹框
			selectAdUnlock: {},
			isShowDialogReturn: false, // 回传弹框
			selectReturn: {},
			selectRecharge: {},
			isShowDialogAgent: true,
			isShowRechargeTable: false,
			countdown:60,//倒计时
			Timer: null, // 定时器
			priceFlagOptions: [
				{
					value: 0,
					label: '纯付费解锁'
				},
				// {
				// 	value: 1,
				// 	label: '纯整剧付费',
				// 	disabled: true
				// },
				{
					value: 2,
					label: '纯广告解锁'
				},
				{
					value: 3,
					label: '单集付费+广告解锁'
				}
			],
			platform: localStorage.getItem('platform'),
			postbackType:1,

		}
	},
	computed: {},
	watch: {
	},
	created() {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isShowDialogAgent = false
		} else {
			this.isShowDialogAgent = true
		}
	},
	mounted: function () {
		this.loading = true
		this.getTableData()
		this.startTimer();
	},
	beforeDestroy(){
		clearInterval(this.Timer); // 清除定时器
	},
	methods: {
		//60s倒计时
		startTimer() {
			this.Timer = setInterval(() => {
				if (this.countdown > 0) {
					this.countdown--;
				} else {
					clearInterval(this.Timer);
					this.loading = true
					this.getTableData()
					this.countdown = 60;
					this.startTimer(); // 重新开始倒计时
				}
			}, 1000);
		},
		// 从组件获取appid
		getAppId(data) {
			this.formInline.appId = data
		},
		// 关闭选剧弹窗
		cancelDialogVideo(data) {
			console.log('cancel')
			this.isShowDialogVideo = data
		},
		// 关闭充值方案弹窗
		cancelDialogRecharge(data) {
			console.log('cancel')
			this.isShowRechargeTable = data
		},
		// 确定剧
		videoSure(data) {
			console.log(data,"dadasd")
			this.ruleForm.svName = data.videolistVo.svName
			this.ruleForm.aliasName = data.videolistVo.aliasName
			this.ruleForm.strategyId = data.id
			this.ruleForm.svId = data.svId
			this.selectVideo = data
			this.ruleForm.priceFlag = data.priceFlag
			this.ruleForm.epPrice = data.epPrice
			this.ruleForm.userFreeEp = data.userFreeEp
		},
		// 删除所选剧
		handleCloseTagVideo(tag) {
			console.log(tag)
			this.ruleForm.svName = ''
			this.ruleForm.aliasName = ''
			this.ruleForm.strategyId = ''
			this.ruleForm.svId = 0
			this.selectVideo = {}
			this.priceFlag = ''
		},
		changeUnlockPlan() {
			if (!this.ruleForm.svName) {
				this.$message.error('请先选择短剧');
			} else if (this.unlockPlan == 1) {
				this.isShowDialogAdUnlock = true
			} else {
				this.isShowRechargeTable = true
			}
		},
		// 关闭广告方案弹窗
		cancelDialogAdUnlock(data) {
			console.log('cancel')
			this.isShowDialogAdUnlock = data
		},
		// 确定广告方案
		adUnlockSure(data) {
			this.ruleForm.posterName = data.programme
			this.ruleForm.posterId = data.id
			this.selectAdUnlock = data
			this.ruleForm.rechargeName = ''
			this.ruleForm.rechargeId = ''
			this.selectRecharge = {}
		},
		//确定选择充值方案
		rechargeSure(data) {
			this.ruleForm.rechargeName = data.planName
			this.ruleForm.rechargeId = data.id
			this.selectRecharge = data
			this.ruleForm.posterName = ''
			this.ruleForm.posterId = ''
			this.selectAdUnlock = {}
		},
		// 删除所选广告方案
		handleCloseTagAdUnlock(tag) {
			console.log(tag)
			this.ruleForm.posterName = ''
			this.ruleForm.posterId = ''
			this.selectAdUnlock = {}
			this.ruleForm.rechargeName = ''
			this.ruleForm.rechargeId = ''
			this.selectRecharge = {}
		},
		// 关闭回传方案弹窗
		cancelDialogReturn(data) {
			console.log('cancel')
			this.isShowDialogReturn = data
		},
		// 确定回传方案
		returnSure(data,returnPlatform) {
			console.log("----",data,returnPlatform)
			this.ruleForm.postbackName = data.title
			this.ruleForm.postbackId = data.id
			this.ruleForm.postType = data.postType
			// if(returnPlatform == 2){
			// 	if(data.type == 1) {
			// 		// this.$set(this.ruleForm.postType, 3);
			// 		this.ruleForm.postType=3
			// 	}
			// 	if(data.type == 2) {
			// 		// this.$set(this.ruleForm.postType, 4);
			// 		this.ruleForm.postType=4
			// 	}
			// }else{
			// 	this.ruleForm.postType = data.type
			// }
			this.selectReturn = data
		},
		// 删除所选回传方案
		handleCloseTagReturn(tag) {
			console.log(tag)
			this.ruleForm.postbackName = ''
			this.ruleForm.postbackId = ''
			this.selectReturn = {}
		},
		//选择充值方案
		// changeRecharge() {
		// 	if (this.ruleForm.posterName) {
		// 		this.$message.error('广告解锁方案和充值方案，只能配置一个');
		// 	} else {
		// 		this.isShowRechargeTable = true
		// 	}
		// },
		// 删除所选充值方案
		// handleCloseTagRecharge(tag) {
		// 	console.log(tag)
		// 	this.ruleForm.rechargeName = ''
		// 	this.ruleForm.rechargeId = ''
		// 	this.selectRecharge = {}
		// },
		search () {
			this.loading = true
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery() {
			this.loading = true
			this.$refs['formInline'].resetFields()
			this.getTableData()
		},
		// 添加表格
		addData() {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogTitle = '添加'
			this.ruleForm = {
				addTime: '',
				aliasName: '',
				svId: 0,
				svName: '',
				agentId: '',
				appPath: '',
				appid: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId,
				appidName: JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName,
				epNumber: 1,
				id: '',
				link: '',
				linkDescribe: '',
				postbackId: '',
				postbackName: '',
				posterId: '',
				posterName: '',
				rechargeId: '',
				rechargeName: '',
				strategyId: '',
				title: '',
				updateType: "add",
				priceFlag:'',
				userFreeEp:'',
				epPrice:'',
				postType:'',

			}
			this.selectVideo = {}
			this.dialogFormVisible = true
		},
		handleLook(id) {
			this.dialogInfoVisible = true
			this.getDetails(id, 'look')
		},
		// 删除
		handleDelete(id) {
			console.log(id)
			del({
				infoId: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage = this.currentPage - 1
					}
					this.$refs[id].doClose()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 编辑
		handleEdit(id) {
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogTitle = '编辑'
			this.getDetails(id, 'edit')
			this.dialogFormVisible = true
		},
		// 获取详情
		getDetails(id, text) {
			details({
				infoId: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.rowForm = response.data.content
					this.ruleForm = response.data.content
					if (text == 'edit') {
						this.ruleForm.addTime = ''
						this.ruleForm.updateType = 'edit'
						if(this.ruleForm.rechargeId){
							this.unlockPlan = 2
							if(this.platform == 'wx-sv' || this.platform == 'wx-gg-sv'){
								this.postbackType = 4
							}else{
								this.postbackType = 2
							}
						}else{
							this.unlockPlan = 1
							if(this.platform == 'wx-sv' || this.platform == 'wx-gg-sv'){
								this.postbackType = 3
							}else{
								this.postbackType = 1
							}
						}
					}
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 弹框确定
		editDialogSureBtn() {
			console.log(this.ruleForm)
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm.updateType)
					this.saveTableData()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData() {
			add(this.ruleForm).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableData()
					this.dialogFormVisible = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			list(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.loading = false
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
		handleCurrentChange(value) {
			this.loading = true
			this.currentPage = value
			this.getTableData()
		},
		handleSizeChange(val) {
			this.loading = true
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		// 一键填充id
		handleGoRecharge(id) {
			console.log(id)
			this.$router.push({ path: '/video-recharget-list', query: { id: id } })
		},
		//暂停/开启数据更新
		DataUpdates(row){
			const info = {
				disable:row.disable == 1?0:1,
				infoId:row.id
			}
			disable(info).then(response => {
				if (response.data.head.flag === 0) {
					this.loading = true
					this.getTableData()
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
			
		},
		// 复制监控链接
		copyLink(key){
			const appId =  localStorage.getItem('appId') || JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
			const appName =  localStorage.getItem('appName') || JSON.parse(localStorage.getItem('accountInfo')).bangdingAppName
			let linkUrl = ''
			if(key == 'gdt'){
				linkUrl = `https://short.zuok.cn/short/videoMonitoringLinkData/addWxListenAd/${appId}?callback=__CALLBACK__&account_id=__ACCOUNT_ID__&click_id=__CLICK_ID__&click_time=__CLICK_TIME__&wechat_openid=__WECHAT_OPEN_ID__&request_id=__REQUEST_ID__&adgroup_id=__ADGROUP_ID__&dynamic_creative_id=__DYNAMIC_CREATIVE_ID__&click_sku_id=__CLICK_SKU_ID__&promoted_object_id=__PROMOTED_OBJECT_ID__&impression_id=__IMPRESSION_ID__`
			}
			if(key == 'jl'){
				linkUrl = `https://short.zuok.cn/short/videoMonitoringLinkData/addListenAd?aid=__AID__&aidName=__AID_NAME__&androidId=__ANDROIDID__&appId=${appId}&convertId=__CONVERT_ID__&csite=__CSITE__&geo=__GEO__&idfa=__IDFA__&imei=__IMEI__&ip=__IP__&ipv4=__IPV4__&ipv6=__IPV6__&mac=__MAC__&model=__MODEL__&oaid=__OAID__&os=__OS__&platform=1&projectId=__PROJECT_ID__&projectName=__PROJECT_NAME__&promotionId=__PROMOTION_ID__&promotionName=__PROMOTION_NAME__&requestId=__REQUEST_ID__&ts=__TS__&ua=__UA__`
			}
			
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(linkUrl).then(() => {
					this.$message({
						message: `复制成功，链接仅用于${appName}使用`,
						type: 'success'
					})
				}).catch(err => {
					console.log(err,"复制失败")
					this.$message({
						message: `复制失败`,
						type: 'error'
					})
				})
			}
			if(!navigator.clipboard){
				let oInput = document.createElement('input')
				oInput.value = linkUrl
				document.body.appendChild(oInput)
				oInput.select() // 选择对象
				document.execCommand("Copy") // 执行浏览器复制命令
				this.$message({
					message: `复制成功，链接仅用于${appName}使用`,
					type: 'success'
				})
				oInput.remove()
			}
		},
		// 通用复制方法
		copyText(url){
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(url).then(() => {
					this.$message({
						message: `复制成功`,
						type: 'success'
					})
				}).catch(err => {
					console.log(err)
					this.$message({
						message: `复制失败`,
						type: 'error'
					})
				})
			}
			if(!navigator.clipboard){
				let oInput = document.createElement('input')
				oInput.value = url
				document.body.appendChild(oInput)
				oInput.select() // 选择对象
				document.execCommand("Copy") // 执行浏览器复制命令
				this.$message({
					message: `复制成功`,
					type: 'success'
				})
				oInput.remove()
			}
		},
		// 复制访问链接---微信
		copyWxUrl(row){
			const [baseUrl, queryParams] = row.appPath.split('?');
			console.log("复制访问链接",baseUrl, queryParams)
			this.axios({
        method: 'get',
        url: '/video/postlink/getWxUrl',
        params: {
					path:baseUrl,
					query:queryParams
				}
      }).then((response) => {
        if (response.data.head.flag === 0) {
					this.copyText(response.data.content)
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
		},
		// 复制访问链接---抖音
		copyDyUrl(row){
			const [baseUrl, queryParams] = row.appPath.split('?');
			console.log("复制访问链接",baseUrl, queryParams)
			this.axios({
        method: 'get',
        url: '/video/strategy/details',
        params: {
					infoId:row.strategyId
				}
      }).then((response) => {
        if (response.data.head.flag === 0) {
					console.log("----",response.data.content)
					const videoInfo = response.data.content
					this.axios({
						method: 'get',
						url: '/video/postlink/getDyUrl',
						params: {
							path:baseUrl,
							query:{
								tt_album_id: videoInfo.albumId,
								tt_episode_id: videoInfo.videolistVo.epId,
								app_id: row.appid,
								seq: '1',
								is_continue: '1',
								videoId: row.svId,
								tfId: row.id,
								agentId: row.agentId
							}
						}
					}).then((response) => {
						if (response.data.head.flag === 0) {
							this.copyText(response.data.content)
						} else {
							this.$message.error(response.data.head.desc)
						}
					})
        } else {
          this.$message.error(response.data.head.desc)
        }
      })
			
		},

		// 切换解锁类型
		changePriceFlag(val){
			console.log("借宿",val)
			if(val == 2){
				this.unlockPlan = 1
				if(this.platform == 'wx-sv' || this.platform == 'wx-gg-sv'){
					this.postbackType = 3
				}else{
					this.postbackType = 1
				}
			}else{
				this.unlockPlan = 2
				if(this.platform == 'wx-sv' || this.platform == 'wx-gg-sv'){
					this.postbackType = 4
				}else{
					this.postbackType = 2
				}
			}
		}
		
	}
}
</script>
<style scoped lang="scss">
.ml-16{
	margin-left: 16px;
}
</style>
